/**
 * GET /api/org/opcos — list of OpCos visible to the caller.
 *
 * Used by useOpcos hook (Phase 1 of TASK-079). Replaces `data.opcos ?? data`
 * defensive coercion at multiple admin pages.
 */
import { z } from 'zod';

export const OpcoSchema = z.looseObject({
  opcoId: z.string().min(1),
  name: z.string().min(1).optional(),
  status: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  domain: z.string().nullable().optional(),
  logoUrl: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  parentOpcoId: z.string().nullable().optional(),
});

export type Opco = z.infer<typeof OpcoSchema>;

/** GET /api/org/opcos — `{ opcos: Opco[], manageableGroups?: string[] | null }`.
 *
 * `manageableGroups` is null/undefined for admins (manages every group) and a
 * `string[]` for leaders (the operating-group names they own). It must be
 * accepted (not stripped) so consumers can branch on `null` vs array.
 */
export const OpcosListResponseSchema = z.looseObject({
  opcos: z.array(OpcoSchema),
  manageableGroups: z.array(z.string()).nullable().optional(),
});

export type OpcosListResponse = z.infer<typeof OpcosListResponseSchema>;
